<template>
  <section class="panel">
    <div class="panel-head">
      <h3>Chats</h3>
      <button class="more-btn">⋮</button>
    </div>

    <div class="search-box">
      <input type="text" placeholder="Search for keywords" />
    </div>

    <div class="tabs">
      <button class="tab active">Open</button>
      <button class="tab">Queued</button>
      <button class="tab">Closed</button>
    </div>

    <div class="section-title">Today</div>

    <div class="chat-list">
      <ChatCard
        v-for="chat in chats"
        :key="chat.id"
        :chat="chat"
        :active="chat.id === activeChatId"
        @click="$emit('select-chat', chat.id)"
      />
    </div>
  </section>
</template>

<script setup>
import ChatCard from "./ChatCard.vue";

defineProps({
  chats: Array,
  activeChatId: Number,
});

defineEmits(["select-chat"]);
</script>

<style scoped>
.panel {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.panel-head {
  padding: 16px 16px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.panel-head h3 {
  margin: 0;
  font-size: 18px;
}

.more-btn {
  border: none;
  background: transparent;
  font-size: 20px;
  cursor: pointer;
}

.search-box {
  padding: 0 12px 12px;
}

.search-box input {
  width: 100%;
  height: 40px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 0 12px;
}

.tabs {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 0 12px 12px;
  gap: 0;
}

.tab {
  height: 42px;
  border: 1px solid #d1d5db;
  background: #fff;
  cursor: pointer;
  font-size: 14px;
}

.tab:first-child {
  border-radius: 10px 0 0 10px;
}

.tab:last-child {
  border-radius: 0 10px 10px 0;
}

.tab.active {
  background: #6b7280;
  color: #fff;
}

.section-title {
  padding: 0 14px 10px;
  font-size: 14px;
  font-weight: 600;
  color: #6b7280;
}

.chat-list {
  padding: 0 12px 12px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>